import { render } from "./printFunctionComponent.vue?vue&type=template&id=0c9e7bc8&scoped=true"
import script from "./printFunctionComponent.vue?vue&type=script&lang=js"
export * from "./printFunctionComponent.vue?vue&type=script&lang=js"

import "./printFunctionComponent.vue?vue&type=style&index=0&id=0c9e7bc8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9e7bc8"]])

export default __exports__